import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Spin,
  Col,
  Divider,
  Transfer,
  message,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
// import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./productMix.config";

import styles from "../../../assets/styles/styles";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewProductMix = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [productData, setProductData] = useState([]);
  const [allowedProductData, setAllowedProductData] = useState([]);
  const [restrictedProductsData, setRestrictedProductsData] = useState([]);

  useEffect(() => {
    getTemplate();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.ProductMixTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res?.productOptions;
        const tempProduct = [];

        objList?.forEach((element) => {
          tempProduct.push({
            value: element.id,
            label: element.name,
          });
        });

        setProductData(tempProduct);
      }
    });
  }
  function getSpecificTemplate(idParam) {
    const url = `${apiConfig.Loanproducts}/${idParam}/productmix?template=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        const tempAllowedProd = [];
        const tempRestrictedProd = [];

        objList?.allowedProducts?.forEach((element) => {
          tempAllowedProd.push({
            // key: element.id,
            value: element.id,
            label: element.name,
          });
        });

        objList?.restrictedProducts?.forEach((element) => {
          tempRestrictedProd.push(element.id);
        });

        setAllowedProductData(tempAllowedProd);
        // setRestrictedProductsData(tempRestrictedProd);
      }
    });
  }

  const handleChange = (newTargetKeys, direction, moveKeys) => {
    // console.log(newTargetKeys, direction, moveKeys);
    // setRestrictedProductsData([...newTargetKeys]);
    setRestrictedProductsData(newTargetKeys);
  };
  const renderItem = (item) => {
    return {
      label: item.label,
      value: item.value,
    };
  };

  function onCancel() {
    navigate("/prd0606", { replace: false });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Loanproducts}/${formValues.selectedProductId}/productmix`;

    if (restrictedProductsData.length === 0) {
      message.warning(`${labelConfig.restrictedProducts} is required`);
      return
    }
    formValues.restrictedProducts = restrictedProductsData;

    delete formValues.selectedProductId;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newProductMixMsg);
        navigate("/product-mix-detail", { state: { id: res.productId } });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newProductMix}
        pageItems={staticConfig.newBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{}}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.productMixSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.generalInfo}
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.productLoan}
                  name="selectedProductId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.productLoan),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.productLoan}`,
                      "select"
                    )}
                    onChange={getSpecificTemplate}
                    options={productData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.loanAccountsInfo}
              </Divider>

              <Col span={24} style={{ padding: "0px 8px" }}>
                <Transfer
                  titles={[
                    labelConfig.allowedProducts,
                    labelConfig.restrictedProducts,
                  ]}
                  dataSource={allowedProductData}
                  listStyle={{
                    width: 400,
                    // height: 500,
                  }}
                  targetKeys={restrictedProductsData}
                  onChange={handleChange}
                  render={renderItem}
                  rowKey={(record) => record.value}
                />
              </Col>
            </Row>
            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewProductMix);
